import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/pt';
export const locale = {
  lang: 'pt',
  data: {
    'CONSULTA': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
        'PRODUCTOS': catalogos.productos,
      },
      'TITULO': 'Calendário de inquéritos',
      'SUBTITULO': 'Consulte a informação dos inquéritos gerados na plataforma numa gama específica',
      'TXT_RANG_DAT': 'Introduzir um intervalo de datas',
      'BTN_CANC': 'Cancelar',
      'BTN_APLI':'Aplicar',
      'MOD_TITT_INFO': 'Informação de Inquérito',
      'TXT_NAM_COMPA': 'Nome da empresa:  ',
      'TXT_NAM_TOKEN':'Ficha de inquérito:  ',
      'TXT_DAT_LAN':'Data de lançamento:  ',
      'TXT_DAT_CLOS': 'Data de encerramento:  ',
      'TXT_SUR_STA': 'Estado do inquérito:  ',
      'TXT_TIP_SUR':'Tipo de produto:  ',
      'TXT_YEA_SUR': 'Ano do inquérito:  ',
      'ESTATUS':{
        '0': 'Inactivo',
        '1': 'Activo',
        '2': 'Fechado',
      },
      'CAMPOS': {
        'broker': 'Broker',
      },
    }
  }
};
